import { getLang } from "helpers/themeHelpers";
import { IPackage } from "models/cheapestPackage";
import {isBrowser} from "utils/nookies/utils";

export const linkToCarsForm = () => {
    const locale = getLang();
    return `/${locale}/motors-for-sale/sell-it-for-me/car-info`;
};
export const linkToRentForm = (type="") => {
    const locale = getLang();
    return `/${locale}/property-for-rent/rent-it-for-me/property-info${type ? "?type="+type:""}`;
};
export const linkToSaleForm = (type="") => {
    const locale = getLang();
    // return `/en/property-for-sale/sell-it-for-me/property-info?type=Lands`
    return `/${locale}/property-for-sale/sell-it-for-me/property-info${type ? "?type="+type:""}`;
};
    export const linkToCarsSellItForMe = () => {
    const locale = getLang();
    return `/${locale}/motors-for-sale/sell-it-for-me`;
};
export const linkToPropertySellItForMe = () => {
    const locale = getLang();
    return `/${locale}/property-for-sale/sell-it-for-me`;
};
export const linkToPropertyRentItForMe = () => {
    const locale = getLang();
    return `/${locale}/property-for-rent/rent-it-for-me`;
};
export const linkToSellAnything = () => {
    const locale = getLang();
    return `/${locale}/sell-any-thing`;
};

export const linkToCarsLanding = () => {
    const locale = getLang();
    return `/${locale}/motors/sell-my-car`;
}

export const linkToPropertyForSaleLanding = () => {
    const locale = getLang();
    return `/${locale}/property-for-sale/sell-my-property`;
}

export const linkToPropertyForRentLanding = () => {
    const locale = getLang();
    return `/${locale}/property-for-rent/rent-my-property`;
}

export const linkToJobsFind = () => {
    const locale = getLang();
    return `/${locale}/jobs/find-a-job`;
}

export const linkToJobsHire = () => {
    const locale = getLang();
    return `/${locale}/jobs/hire-people`;
}
export const linkToAddEditCv = (platform) => {
    const lang = getLang();
    return `${process.env.NEXT_PUBLIC_ADD_POST_TEMPLATE_URL}?v=2&source=${platform}&lang=${lang}&flow=my-cv`;
};
export const linkToServices = () => {
    const locale = getLang();
    return `/${locale}/services`;
}
export const linkToAdvertisingProducts= () => {
    const locale = getLang();
    return `/${locale}/advertising-products`;
}